<div class="card" id="identificareAnimal" [formGroup]="animalForm">
  <div class="card-header">
    Identificare animal

    <ng-select
      formControlName="status"
      [items]="[
        {'value': 1, 'label': 'Activ'},
        {'value': -1, 'label': 'Inactiv'}
      ]"
      bindValue="value"
      bindLabel="label"
      [clearable]="false"
      [searchable]="false"
      class="fs-5 font-weight-bold"
      [ngClass]="{ disabled: disabledFields['status'] }"
    >
      <ng-template ng-option-tmp ng-label-tmp let-item="item">
        <div
          [ngClass]="{
            'text-success': item['value'] === 1,
          }"
        >
          {{ item['label'] }}
        </div>
      </ng-template>
    </ng-select>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-auto">
        <div class="form-group mb-3">
          <label>
            Număr matricol
          </label>
          <input
            type="text"
            placeholder="Adaugă număr matricol"
            class="form-control w12"
            formControlName="numarmatricol"
            (input)="numarmatricolChange($event)"
            *ngIf="
              modalType === 'add' ||
              modalType === 'edit' ||
              modalType === 'view'
            "
            [ngClass]="{
              'is-invalid': submitted && f.numarmatricol.errors
            }"
            [readonly]="disabledFields['numarmatricol'] && ['view', 'edit'].includes(modalType)"
          />

          <ng-select
            *ngIf="modalType === 'add-mother' || modalType === 'add-father'"
            [items]="searchingAnimals"
            bindLabel="numarmatricol"
            bindValue="numarmatricol"
            formControlName="numarmatricol"
            class="w14"
            [ngClass]="{ 'is-invalid': submitted && f.numarmatricol.errors }"
            (search)="searchAnimal($event)"
            (change)="selectedAnimal($event)"
            (input)="inputSelect($event)"
          >
          </ng-select>

          <div
            *ngIf="submitted && f.numarmatricol.errors"
            class="invalid-feedback"
            [ngClass]="{ 'd-block': submitted && f.numarmatricol.errors }"
          >
            <div *ngIf="f.numarmatricol.errors.required">
              Completarea acestui câmp este obligatorie.
            </div>
          </div>
        </div>
      </div>

      <div class="col-auto">
        <div class="form-group mb-3">
          <label>
            Sex
          </label>

          <ng-select
            formControlName="sex"
            [items]="[
              {'value': '1', 'label': 'Mascul'},
              {'value': '2', 'label': 'Femelă'}
            ]"
            bindValue="value"
            bindLabel="label"
            [clearable]="false"
            [searchable]="false"
            class="fs-5"
            [ngClass]="{ disabled: disabledFields['sex'] }"
          >
            <ng-template ng-option-tmp ng-label-tmp let-item="item">
              <div
                [ngClass]="{
                  'color-mascul': item['value'] === '1',
                  'color-femela': item['value'] === '2'
                }"
              >
                {{ item['label'] }}
              </div>
            </ng-template>
          </ng-select>

          <div
            *ngIf="submitted && f.sex.errors"
            class="invalid-feedback"
            [ngClass]="{ 'd-block': submitted && f.sex.errors }"
          >
            <div *ngIf="f.sex.errors.required">
              Alegerea acestui câmp este obligatorie.
            </div>
          </div>
        </div>
      </div>

      <div class="col-auto">
        <div class="form-group">
          <label>
            Data nașterii
          </label>
          <app-date-picker
            [selectedDate]="animalForm.controls.datanastere.value"
            [disabled]="disabledFields['datanastere']"
            (dateChanged)="dataNasteriiChanged($event)"
          >
          </app-date-picker>
        </div>
      </div>

      <div class="col-auto">
        <div class="form-group">
          <label>
            Dată intrare in exploatație
          </label>
          <app-date-picker
            [selectedDate]="animalForm.controls.dataintrareinexploatatie.value"
            [disabled]="disabledFields['dataintrareinexploatatie']"
            [invalid]="dateError"
            (dateChanged)="dataIntrareExploatatieChanged($event)"
          >
          </app-date-picker>
          <div
            *ngIf="dateError"
            class="invalid-feedback"
            [ngClass]="{ 'd-block': dateError }"
          >
            <div *ngIf="dateError">
              Data introdusă nu poate fi mai mică decât data de naștere a
              animalului selectat.
            </div>
          </div>
        </div>
      </div>

      <div class="col-auto">
        <div class="form-group">
          <label>
            Nume
          </label>
          <input
            type="text"
            placeholder="Nume"
            class="form-control w14"
            formControlName="nume"
            (input)="
              animalForm.patchValue({
                nume: $event.target.value.toUpperCase()
              })
            "
            [ngClass]="{ disabled: disabledFields['nume'] }"
          />
        </div>
      </div>

      <div class="col-auto">
        <div class="form-group">
          <label>
            Culoare
          </label>
          <ng-select
            bindLabel="color"
            bindValue="color"
            formControlName="color"
            placeholder="Culoare"
            [searchable]="false"
            [ngClass]="{ disabled: disabledFields['color'] }"
          >
            <ng-option value="0">Alb</ng-option>
            <ng-option value="1">Rosu</ng-option>
            <ng-option value="2">Negru</ng-option>
          </ng-select>
        </div>
      </div>

      <div
        *ngIf="animalForm.value.sex === '2'"
        class="col-auto"
      >
        <div class="form-group">
          <label>
            Categorie Femelă
          </label>
          <ng-select
            bindLabel="categoriefemela"
            bindValue="categoriefemela"
            placeholder="Categorie Femelă"
            formControlName="categoriefemela"
            [searchable]="false"
            [ngClass]="{ disabled: disabledFields['categoriefemela'] }"
          >
            <ng-option value="0">Nespecificat</ng-option>
            <ng-option value="1">Vițea</ng-option>
            <ng-option value="2">Primipară</ng-option>
            <ng-option value="3">Multipară</ng-option>
            <ng-option value="4">Junincă</ng-option>
          </ng-select>
        </div>
      </div>

      <div class="col-auto">
        <div class="form-group">
          <label>
            Obținut prin
          </label>
          <ng-select
            bindLabel="sistemreproductie"
            bindValue="sistemreproductie"
            placeholder="Produs prin"
            formControlName="sistemreproductie"
            [clearable]="false"
            [searchable]="false"
            [ngClass]="{ disabled: disabledFields['sistemreproductie'] }"
          >
            <ng-option value="0">Nespecificat</ng-option>
            <ng-option value="1">Însămânțare artificială</ng-option>
            <ng-option value="2">Montă naturală autorizată</ng-option>
            <ng-option value="3">Embriotransferuri</ng-option>
          </ng-select>
        </div>
      </div>

      <div
        class="col-auto"
        *ngIf="animalForm.value.sistemreproductie === '3'"
      >
        <div class="form-group">
          <label>
            Mamă purtătoare
          </label>

          <ng-select
            [items]="matricoleAnimal"
            (search)="searchMatricol($event, 2)"
            bindLabel="numarmatricol"
            bindValue="id"
            formControlName="mamapurtatoareid"
            class="w14"
            [ngClass]="{ disabled: disabledFields['mamapurtatoareid'] }"
            placeholder="Introduceți număr matricol"
            (clear)="clearMatricoleAnimal()"
            (blur)="clearMatricoleAnimal()"
          >
          </ng-select>
        </div>
      </div>

      <div class="col-auto">
        <div class="form-group">
          <label>
            Tip fătare
          </label>
          <ng-select
            bindLabel="tipfatare"
            placeholder="Fătare"
            [ngClass]="{ disabled: disabledFields['tipfatare'] }"
            [clearable]="false"
            [searchable]="false"
            formControlName="tipfatare"
          >
            <ng-option value="0">Nespecificat</ng-option>
            <ng-option value="1">Simplă</ng-option>
            <ng-option value="2">Gemelară</ng-option>
          </ng-select>
        </div>
      </div>

      <div class="col-auto">
        <div class="form-group mb-3">
          <label>
            Certificat zootehnic
          </label>

          <ng-select
            formControlName="are_certificat_zootehnic"
            [items]="[
              {'value': true, 'label': 'Are CZ'},
              {'value': false, 'label': 'Nu are CZ'}
            ]"
            bindValue="value"
            bindLabel="label"
            [clearable]="false"
            [searchable]="false"
            class="fs-5 font-weight-bold"
            [ngClass]="{ disabled: disabledFields['are_certificat_zootehnic'] }"
          >
            <ng-template ng-option-tmp ng-label-tmp let-item="item">
              <div
                [ngClass]="{
                  'text-success': item['value'],
                  'text-danger': !item['value'],
                }"
              >
                {{ item['label'] }}
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>

      <div
        *ngIf="animalForm.value.eligibilitatecz.length"
        class="col-auto d-flex justify-content-center flex-column text-danger font-weight-bold mb-2"
      >
        <div
          *ngFor="let message of animalForm.value.eligibilitatecz"
        >
          {{ message }}
        </div>
      </div>


      <div class="col-auto">
        <div
          *ngFor="let rasaForm of raseFormArray.controls; let i = index; let first = first"
          [formGroup]="rasaForm"
          class="d-flex"
        >
          <div class="form-group">
            <label>Rasa</label>

            <ng-select
              [items]="raseAnimal"
              bindLabel="name"
              bindValue="id"
              placeholder="Rasa"
              formControlName="raceid"
              (change)="changeRasaAnimal()"
              [ngClass]="{ disabled: disabledFields['rase'] }"
            >
            </ng-select>
          </div>

          <div class="form-group ml-2">
            <label>Procent</label>

            <div class="d-flex align-items-center">
              <input
                type="number"
                min="0"
                max="100"
                placeholder="Procent"
                class="form-control w6"
                formControlName="val"
                (change)="changeRasaAnimal()"
                [ngClass]="{ disabled: disabledFields['rase'] }"
              />
              <span class="fs-5 font-weight-bold pl-1">%</span>

              <button
                *ngIf="!first && !disabledFields['rase']"
                type="button"
                class="btn fs-3 p-0 ml-2 text-danger mdi mdi-close-circle"
                (click)="removeAnimalBreed(i)"
              >
              </button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="
        !animalForm.value.rase.length
        && animalForm.value.tataid
        && animalForm.value.mamaid
      ">
        <label>Rasa</label>
        <div>Se va actualiza după salvare</div>
      </div>


      <div class="col-auto">
        <div class="form-group mb-3">
          <label>
            Corespunde rasei?
          </label>

          <ng-select
            formControlName="corespunde_standard"
            [items]="[
              {'value': true, 'label': 'Corespunde'},
              {'value': false, 'label': 'Nu corespunde'}
            ]"
            bindValue="value"
            bindLabel="label"
            [clearable]="false"
            [searchable]="false"
            (change)="clickCorespundeStandard()"
            class="fs-5 font-weight-bold"
            [ngClass]="{ disabled: disabledFields['corespunde_standard'] }"
          >
            <ng-template ng-option-tmp ng-label-tmp let-item="item">
              <div
                [ngClass]="{
                  'text-success': item['value'],
                  'text-danger': !item['value'],
                }"
              >
                {{ item['label'] }}
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>

      <div class="col-auto" *ngIf="animalForm.value.hist_corespunde_standard">
        <table
          *ngIf="animalForm.value.hist_corespunde_standard.length"
          class="table-sm table-bordered zoom-sm-50 zoom-lg-75 mb-2"
        >
          <tr>
            <th>Data</th>
            <th>Status vechi</th>
            <th>Status nou</th>
            <th>Observație</th>
            <th>Numele și username</th>
          </tr>
          <tr *ngFor="let item of animalForm.value.hist_corespunde_standard">
            <td>{{ item.data_dmy }}</td>
            <td>
              <span
                *ngIf="item.status_vechi == true"
                class="text-success"
              >Corespunde</span>
              <span
                *ngIf="item.status_vechi != true"
                class="text-danger"
              >Nu corespunde</span>
            </td>
            <td>
              <span
                *ngIf="item.status_nou == true"
                class="text-success"
              >Corespunde</span>
              <span
                *ngIf="item.status_nou != true"
                class="text-danger"
              >Nu corespunde</span>
            </td>
            <td class="max-w30">{{ item.observatie }}</td>
            <td>{{ item.user_full_name }} ({{ item.username }})</td>
          </tr>
        </table>
      </div>

    </div>


    <div class="row column-gap-5">
      <div class="col-auto mb-3">
        <label>Exploatație</label>

        <div class="d-flex align-items-center">
          <div class="flex-grow-1">
            <ng-select
              [items]="holdingsNames"
              bindLabel="name"
              bindValue="id"
              [ngClass]="{ disabled: disabledFields['exploatatieid'] }"
              placeholder="Alege exploatație"
              formControlName="exploatatieid"
              (change)="selectareExploatatie($event)"
            >
              <ng-template ng-label-tmp ng-option-tmp let-item="item">
                {{ item.name }} -
                <span *ngIf="item.status === 5">import</span>
                <span *ngIf="item.status !== 5">{{ item.code }}</span>
              </ng-template>
            </ng-select>
          </div>

          <a
            *ngIf="animalForm.value.cod_exploatatie"
            [routerLink]="'/dashboard/exploatatie/'
              + animalForm.value.cod_exploatatie
              +'/animale-exploatatie'"
            target="_blank"
            class="fs-3 ml-1"
            title="Pagina exploatației"
          ><i class="mdi mdi-open-in-new"></i>
          </a>
        </div>
      </div>

      <div class="col-auto mb-3">
        <div class="position-relative">
          <label>Crescător</label>

          <button
            *ngIf="!disabledFields['crescatorid']"
            type="button"
            class="btn text-blue fs-3 p-0 ml-2 position-absolute bottom-0"
            ngbTooltip="Creează exploatație"
            (click)="openAddHoldingModal()"
          >
            <span class="mdi mdi-plus-circle"></span>
          </button>
        </div>

        <div class="d-flex align-items-center">
          <div class="flex-grow-1">
            <ng-select
              [items]="holdingsNameForOwners"
              bindLabel="name"
              bindValue="id"
              placeholder="Alege crescător"
              [ngClass]="{ disabled: disabledFields['crescatorid'] }"
              formControlName="crescatorid"
              (change)="selectareCrescator($event)"
            >
              <ng-template ng-label-tmp ng-option-tmp let-item="item">
                {{ item.name }} -
                <span *ngIf="item.status === 5">import</span>
                <span *ngIf="item.status !== 5">{{ item.code }}</span>
              </ng-template>
            </ng-select>
          </div>

          <a
            *ngIf="animalForm.value.cod_crescator"
            [routerLink]="'/dashboard/exploatatie/'
              + animalForm.value.cod_crescator
              +'/animale-exploatatie'"
            target="_blank"
            class="fs-3 ml-1"
            title="Pagina crescătorului"
          ><i class="mdi mdi-open-in-new"></i>
          </a>
        </div>
      </div>
    </div>

    <div class="row column-gap-3">
      <div class="col-auto">
        <div class="d-flex align-items-center">
          <h5 *ngIf="test_adn.controls.length">
            Teste ADN
          </h5>
          <h5 *ngIf="! test_adn.controls.length">
            Nu are Teste ADN
          </h5>

          <button
            *ngIf="!disabledFields['test_adn']"
            type="button"
            class="btn btn-sm btn-blue ml-3"
            (click)="adaugaTestADN()"
          >
            <span class="mdi mdi-plus-circle"></span>
            Adaugă Test ADN
          </button>
        </div>

        <ng-container formArrayName="test_adn">
          <ng-container *ngFor="let testADNForm of test_adn.controls; let index = index">
            <ng-container [formGroup]="testADNForm">
              <div class="row mb-3">
                <div class="col-auto">
                  <label *ngIf="index == 0">
                    CZ
                  </label>
                  <input
                    type="checkbox"
                    (change)="changeAfiseazaInCZ(testADNForm)"
                    formControlName="afiseaza_in_cz"
                    class="d-block my-2"
                    [ngClass]="{
                      'disabled': testADNForm.controls.readonly.value
                    }"
                  />
                </div>

                <div class="col-auto">
                  <label *ngIf="index == 0">
                    Metoda
                  </label>
                  <ng-select
                    bindLabel="metoda"
                    bindValue="metoda"
                    formControlName="metoda"
                    placeholder="Metoda"
                    [searchable]="false"
                    [ngClass]="{
                      'disabled': testADNForm.controls.readonly.value
                    }"
                  >
                    <ng-option value="ADN">ADN</ng-option>
                    <ng-option value="STR">STR</ng-option>
                    <ng-option value="SNP">SNP</ng-option>
                  </ng-select>
                </div>

                <div class="col-auto">
                  <label *ngIf="index == 0">
                    Tip
                  </label>
                  <ng-select
                    bindLabel="tip"
                    bindValue="tip"
                    formControlName="tip"
                    placeholder="Tip"
                    [searchable]="false"
                    [ngClass]="{
                      'disabled': testADNForm.controls.readonly.value
                    }"
                  >
                    <ng-option value="profil">profil</ng-option>
                    <ng-option value="verificare tata">verificare tata</ng-option>
                    <ng-option value="verificare mama">verificare mama</ng-option>
                    <ng-option value="verificare tata si mama">verificare tata si mama</ng-option>
                    <ng-option value="test genomic">test genomic</ng-option>
                    <ng-option value="atribuirea rasei">atribuirea rasei</ng-option>
                    <ng-option value="reconstituire tata">reconstituire tata</ng-option>
                    <ng-option value="reconstituire mama">reconstituire mama</ng-option>
                    <ng-option value="profil + verificare tata">profil + verificare tata</ng-option>
                    <ng-option value="profil + verificare mama">profil + verificare mama</ng-option>
                    <ng-option value="profil + verificare tata si mama">profil + verificare tata si mama</ng-option>
                    <ng-option value="profil + reconstituire tata">profil + reconstituire tata</ng-option>
                    <ng-option value="profil + reconstituire mama">profil + reconstituire mama</ng-option>
                  </ng-select>
                </div>

                <div class="col-auto">
                  <label *ngIf="index == 0">
                    I.D. R.G.
                  </label>
                  <input
                    type="text"
                    placeholder="I.D. R.G."
                    formControlName="id_rg"
                    class="form-control"
                    [readonly]="testADNForm.controls.readonly.value"
                  />
                </div>

                <div class="col-auto">
                  <label *ngIf="index == 0">
                    Număr ADN
                  </label>
                  <input
                    type="text"
                    placeholder="Număr ADN"
                    formControlName="numar_adn"
                    class="form-control"
                    [readonly]="testADNForm.controls.readonly.value"
                  />
                </div>

                <div class="col-auto">
                  <label *ngIf="index == 0">
                    Data eliberării
                  </label>
                    <app-date-picker
                      [selectedDate]="testADNForm.controls.data_eliberarii.value"
                      [disabled]="
                        testADNForm.controls.data_eliberarii.value
                        && testADNForm.controls.readonly.value
                      "
                      (dateChanged)="dataEliberariiChanged($event, testADNForm)"
                    >
                    </app-date-picker>
                </div>

                <div class="col-auto">
                  <label *ngIf="index == 0">&nbsp;</label>
                  <div class="d-flex align-items-center justify-content-center">
                    <i
                      *ngIf="!testADNForm.controls.readonly.value"
                      class="mdi mdi-close-circle text-danger fs-3 cursor-pointer"
                      ngbTooltip="Șterge"
                      (click)="openDeleteModal(index)"
                    ></i>
                  </div>
                </div>

              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>

      <div class="col-auto">
        <div class="d-flex align-items-center">
          <h5>Fișiere Test ADN</h5>
          <app-upload-fisier
            *ngIf="!disabledFields['test_adn_files']"
            class="ml-3"
            (ApiResponse)="uploadServerResponse($event)"
          >
          </app-upload-fisier>
        </div>

        <ng-container formArrayName="test_adn_files">
          <ng-container *ngFor="let testADNFileForm of test_adn_files.controls; let index = index">
            <div>
              <span
                class="file-button"
                (click)="downloadFisierTestADN($event, testADNFileForm)"
              >
                {{ testADNFileForm.value.uploaded_file_name }}
              </span>
              <button
                *ngIf="!disabledFields['test_adn_files']"
                type="button"
                class="btn btn-lg p-0 ml-2 mdi mdi-delete text-danger"
                ngbTooltip="Șterge fișier"
                (click)="deleteFisierTestADN(index)"
              >
              </button>
            </div>
          </ng-container>
        </ng-container>
      </div>

    </div>

  </div>
</div>

<app-add-update-holding
  [open]="openAddEditModal"
  (notifyClose)="closeAddUpdateModal($event)"
  [modalType]="'add'"
  [holdingData]="holdingData"
  (callbackResult)="updateHoldingsList($event)"
>
</app-add-update-holding>

<app-confirm-action-modal
  [open]="openDelete"
  [text]="'Șterge Testul ADN?'"
  (confirm)="closeDeleteModal($event)"
></app-confirm-action-modal>


<ng-template #corespundeStandardModal let-modal="close">
  <div class="modal-header">
    <div class="modal-title">
      Modificare: Corespunde Rasei
    </div>

    <button
      type="button"
      class="close"
      aria-hidden="true"
      (click)="modal('Cross click'); closeModalCorespundeStandard()"
    >
      ×
    </button>
  </div>

  <div class="modal-body">
    <div class="container-fluid">

      <div>
        Animalul {{ animalForm.value.numarmatricol }}
        <br>
        Status nou:
        <span
          *ngIf="animalForm.value.corespunde_standard == true"
          class="text-success"
        >Corespunde</span>
        <span
          *ngIf="animalForm.value.corespunde_standard != true"
          class="text-danger"
        >Nu corespunde</span>
      </div>

      <div class="row mt-2">
        <div class="col-12">
          <div class="form-group mb-3">
            <label>
              Observație (opțional)
            </label>

            <textarea
              [(ngModel)]="observatie"
              rows="3"
              maxlength="200"
              class="form-control text-area"
            ></textarea>
          </div>
        </div>
      </div>

      <div
        *ngIf="!animalForm.value.poze.length"
        class="text-danger font-weight-bold"
      >
        Animalul nu are poze
      </div>

      <div class="row p-2">
        <div class="col-sm-12 text-right">
          <button
            class="btn btn-dark mr-2"
            type="button"
            (click)="modal('Cross click'); closeModalCorespundeStandard()"
          >
            Anulează
          </button>
          <button
            *ngIf="!disabledFields['corespunde_standard_actualizare']"
            class="btn btn-success"
            type="button"
            (click)="modal('Cross click'); confirmareCorespundeStandard(true)"
          >
            Actualizează
          </button>
        </div>
      </div>

    </div>
  </div>

</ng-template>
